import { render, staticRenderFns } from "./UserInformationForm.vue?vue&type=template&id=5c94a3e0&scoped=true&"
import script from "./UserInformationForm.vue?vue&type=script&lang=js&"
export * from "./UserInformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c94a3e0",
  null
  
)

export default component.exports